(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-popup"] && !Shopify.designMode) return;
  try {
    if (!window.__otfCartQuantitySubmissionReady) {
    window.__otfCartQuantitySubmissionReady = true;

    const syncCartQuantityControls = event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('.quantity__input[name="updates[]"]') || !input.closest('#CartPopup-Form')) return;
      input.closest('.main-cart-item')?.querySelectorAll('.quantity__input[name="updates[]"]').forEach(control => {
        if (control !== input) control.value = input.value;
      });
    };

    document.addEventListener('input', syncCartQuantityControls, true);
    document.addEventListener('change', syncCartQuantityControls, true);
    document.addEventListener('formdata', event => {
      if (!(event.target instanceof HTMLFormElement) || event.target.id !== 'CartPopup-Form') return;
      event.formData.delete('updates[]');
      event.target.querySelectorAll('.main-cart-item').forEach(item => {
        const controls = Array.from(item.querySelectorAll('.quantity__input[name="updates[]"]'));
        const control = controls.find(input => !input.disabled && input.getClientRects().length) || controls[0];
        if (control) event.formData.append('updates[]', control.value);
      });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.querySelector('[data-popup-type="search"]');
  if (!popup || popup.dataset.keyboardReady) return;
  popup.dataset.keyboardReady = 'true';
  let opener = null;
  let wasOpen = false;
  let focusTimer;
  const focusSearch = () => {
    if (popup.classList.contains('hide-popup') || document.body.getAttribute('active-popup') !== 'search') return;
    const active = document.activeElement;
    if (active !== document.body && active !== opener) return;
    const input = popup.querySelector('input[type="search"]');
    if (input && getComputedStyle(input).visibility === 'visible') input.focus({ preventScroll: true });
  };
  const update = () => {
    const isOpen = !popup.classList.contains('hide-popup');
    popup.inert = !isOpen;
    popup.setAttribute('aria-hidden', String(!isOpen));
    if (isOpen && !wasOpen) {
      if (!opener || !opener.isConnected) opener = document.activeElement;
      if (opener?.id === 'Mobile-Search-In-Modal') opener = opener.closest('.header-mobile--search')?.querySelector('.search__button') || null;
      focusSearch();
      clearTimeout(focusTimer);
      focusTimer = setTimeout(focusSearch, 550);
    } else if (!isOpen && wasOpen) {
      clearTimeout(focusTimer);
      if (!document.body.hasAttribute('active-popup') && opener?.isConnected && !popup.contains(opener)) opener.focus();
      opener = null;
    }
    wasOpen = isOpen;
  };
  document.addEventListener('click', event => {
    const trigger = event.target instanceof Element && event.target.closest('[data-modal-type="search"]');
    if (trigger) opener = trigger;
  }, true);
  popup.addEventListener('transitionend', event => {
    if (event.target === popup) focusSearch();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || document.body.getAttribute('active-popup') !== 'search' || popup.classList.contains('hide-popup')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    popup.querySelector('.theme-popup-close')?.click();
  }, true);
  popup.addEventListener('keydown', event => {
    if (popup.classList.contains('hide-popup') || event.key !== 'Tab') return;
    const items = Array.from(popup.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(node => !node.disabled && node.tabIndex >= 0 && node.getClientRects().length);
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }, true);
  new MutationObserver(update).observe(popup, {attributes:true, attributeFilter:['class']});
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
